module.exports = __webpack_public_path__ + "static/media/gazebo-spider-nero-noleggiocampi.ca12d6f9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/strutture/extra/gazebi/gazebo-spider-nero-noleggiocampi.jpg
// module id = 654
// module chunks = 0